import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

import { getOneHorario, actualizarHorario } from "../../../services/horario.service";
import { getAllDias, getOneDia } from "../../../services/dia.service";

import { FormInput } from "../../../components/molecules/FormInput";
import { FormSelect } from "../../../components/atoms/FormSelect";

import {
  showErrorAlert,
  showActualizadoCorrectamenteAlert
} from "../../../components/molecules/ShowAlert";

export const ActualizarHorarioPage = () => {
  const { idHorario } = useParams();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm();

  const [dias, setDias] = useState([]);

  useEffect(() => {
    cargarDatosIniciales();
  }, []);

  const cargarDatosIniciales = async () => {
    try {
      const diasObtenidos = await getAllDias();
      const opcionesDias = diasObtenidos.map(({ idDia, nombre }) => ({
        value: idDia,
        label: nombre,
      }));
      setDias(opcionesDias);

      const horario = await getOneHorario(idHorario);
      setValue("horaInicio", horario.horaInicio);
      setValue("horaFin", horario.horaFin);

      const diaSeleccionado = horario.dia || await getOneDia(horario.idDia);

      if (diaSeleccionado?.idDia) {
        setValue("idDia", {
          value: diaSeleccionado.idDia,
          label: diaSeleccionado.nombre,
        });
      }
    } catch (error) {
      console.error("Error al cargar datos:", error);
      showErrorAlert({ text: "No se pudo cargar el horario" });
    }
  };

  const onSubmit = async ({ idDia, ...rest }) => {
    const payload = {
      ...rest,
      idDia: idDia?.value,
    };

    try {
      await actualizarHorario(idHorario, payload);
      showActualizadoCorrectamenteAlert({
        text: "Horario actualizado correctamente",
        callback: () => navigate("/horarios"),
      });
    } catch (error) {
      console.error("Error al actualizar horario:", error);
      showErrorAlert({ text: "No se pudo actualizar el horario" });
    }
  };

  return (
    <section className="max-w-xl mx-auto bg-white shadow p-6 rounded">
      <h2 className="text-xl font-bold mb-4 text-theme-blue">Actualizar Horario</h2>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <FormInput
          id="horaInicio"
          label="Hora inicio"
          type="time"
          register={register}
          validation={{ required: "Campo obligatorio" }}
          error={errors.horaInicio}
        />

        <FormInput
          id="horaFin"
          label="Hora fin"
          type="time"
          register={register}
          validation={{ required: "Campo obligatorio" }}
          error={errors.horaFin}
        />

        <FormSelect
          label="Día"
          name="idDia"
          control={control}
          options={dias}
          placeholder="Selecciona un día"
          validation={{ required: "Campo obligatorio" }}
          error={errors.idDia}
        />

        <div className="flex justify-end pt-4 gap-4">
          <button
            type="button"
            onClick={() => navigate("/horarios")}
            className="bg-gray-400 hover:bg-gray-600 text-white font-semibold px-6 py-2 rounded"
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="bg-theme-yellow text-white font-semibold px-6 py-2 rounded hover:bg-yellow-600"
          >
            Guardar cambios
          </button>
        </div>
      </form>
    </section>
  );
};
